import { ArticleCard } from '@/components/brand-kit/article-card'
import { PressCardImage } from './press-card-image'
import type { PressCardImageData } from '@/lib/press-card-image'

/** Press lists retain their optimized report cover and real findings in the shared article card. */
export function PressArticleCard({ release, finding }: {
  release: { slug: string; title: string; summary: string | null; published_at: string; cardImage?: PressCardImageData | null }
  finding?: string | null
}) {
  return <ArticleCard
    href={`/press/${release.slug}`}
    title={release.title}
    date={release.published_at}
    dateTimeZone="UTC"
    badge="Research"
    excerpt={release.summary && release.summary !== release.title ? release.summary : undefined}
    imageContent={<PressCardImage image={release.cardImage ?? null} slug={release.slug} />}
    className="h-full"
  >
    {finding && <p className="mt-3 text-[13px] font-medium text-gray-900 bg-[#0469f0]/[0.04] border-l-2 border-[#ff9951] pl-2.5 pr-2 py-1.5 rounded-r-md leading-snug">{finding}</p>}
    <span className="mt-3 block text-sm font-medium text-[#0469f0]">Read full report</span>
  </ArticleCard>
}
